"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _react = _interopRequireDefault(require("react"));

var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));

var Yoga = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(Yoga, _React$PureComponent);

  var _super = (0, _createSuper2["default"])(Yoga);

  function Yoga() {
    (0, _classCallCheck2["default"])(this, Yoga);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(Yoga, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], this.props, /*#__PURE__*/_react["default"].createElement("path", {
        d: "M9.99998919,4.00025487 C9.99998919,5.10000754 10.8999941,6 12,6 L12,6 C13.1000059,6 14.0000108,5.10000754 14.0000108,4.00025487 L14.0000108,4.00025487 C14.0000108,2.90000219 13.1000059,2 12,2 L12,2 C10.8999941,2 9.99998919,2.90000219 9.99998919,4.00025487 L9.99998919,4.00025487 Z M3.99995676,7.00001216 C3.4162036,7.00001216 2.94495106,7.5072634 3.00520138,8.10251484 C3.05770167,8.62151611 3.5257042,9.00001216 4.04695701,9.00001216 L8.99998378,9.00001216 L8.99998378,21.0000462 C8.99998378,21.5837976 9.50698652,22.0550488 10.1024897,21.9947986 C10.6214925,21.9422985 11,21.4742974 11,20.9527961 L11,15.9997841 L12.9513062,15.9997841 L14.0358765,17.2778764 L12.5695352,18.5395019 C12,19.1610631 12.8383092,20.4231306 13.830542,19.808505 L15.8676188,17.9990999 C16.2213738,17.684882 16.2714186,17.1504016 15.9821431,16.7759751 L15.0000162,15.5047496 L15.0000162,9.00001216 L19.953043,9.00001216 C20.4742958,9.00001216 20.9422983,8.62151611 20.9947986,8.10251484 C21.0550489,7.5072634 20.5837964,7.00001216 20.0000432,7.00001216 L3.99995676,7.00001216 Z"
      }));
    }
  }]);
  return Yoga;
}(_react["default"].PureComponent);

var _default = Yoga;
exports["default"] = _default;